import { styled } from '@mui/material/styles'

export const LinkButton = styled('a', {
  name: 'LinkButton',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
})`
  :hover {
    text-decoration: none;
  }
`
